const AboutHero = () => {
  return (
    <section className="pt-32 pb-24 bg-gradient-to-b from-[#F8F9FA] to-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div
              className="relative rounded-2xl overflow-hidden h-[500px] bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/107d66d5c2e1b043fc20eadb2c0e5a41.jpg)',
              }}
            >
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[#0066FF] uppercase text-sm font-semibold tracking-wide mb-4">About Decimal Esporte</p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0A1628] mb-6">
              People-first consultancy for the sports industry
            </h1>
            <div className="space-y-4 text-gray-600 text-lg leading-relaxed max-w-2xl">
              <p>
                Founded in 2022 and based in Portugal, Decimal Esporte is a specialist HR consultancy dedicated to the sports sector. We understand that sport is about people—their talent, performance, and potential.
              </p>
              <p>
                We partner with sports clubs, federations, academies, event organisers, athlete management structures, and individual professionals to build high-performing teams and sustainable organisations.
              </p>
              <p>
                Our approach combines HR expertise with a deep understanding of the unique challenges and opportunities in sport. From talent development to organisational change, we deliver practical solutions that drive real results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
